import React from 'react';
import { ExDrawButton } from './buttons/DrawButton';
import Button from '../button';
import LabelsButton from './buttons/LabelsButton';
import LayersButton from './buttons/LayersButton';
import useLayersStore from '../stores/layersStore';

function BottomSection() {
  const { setInfoOverlayOpened, infoOverlayOpened, featureEnabled } = useLayersStore();
  return (
    <div id="BottomSection" className='absolute bottom-0 flex justify-between items-center p-4 w-full pointer-events-none'>
      <div className='flex gap-2'>
        <LabelsButton />
      </div>
      <div className='flex gap-2'>
        <LayersButton />
      </div>
      <div className='flex gap-2'>
        <ExDrawButton />
        {featureEnabled.info && (
          <Button className="flex gap-1 pointer-events-auto" onClick={() => setInfoOverlayOpened(!infoOverlayOpened)}>
            <div className="hidden sm:block">UI Help</div>
            <svg
              width="20px"
              height="20px"
              viewBox="0 0 17 16"
              fill="#000000"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
              <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"/>
            </svg>
          </Button>
        )}
      </div>
    </div>
  );
}

export default BottomSection; 